'use strict';
import React from 'react';
import * as T from 'prop-types';
import classNames from 'classnames';
import {Button} from '../../buttons/Button';
import {SvgIcon} from '../../../core-components/svg-menu-icons/SvgIcon';
import {SvgIcons} from '../../../core-components/svg-menu-icons/icons';


export function ViewHeaderView(props) {
  return (
    <div className={classNames("ViewHeader", props.className)}>
      {props.enableMenuButton ? (
        <div className="ViewHeader__menuButtonWrapper">
          <Button
            className="ViewHeader__menuButton"
            activeClassName="ViewHeader__menuButton_active"
            iconClass="ion-navicon"
            onClick={props.onToggleMenu}
          />
        </div>
      ) : null}
      {props.showBackButton ? (
        <Button
          className="ViewHeader__backButton"
          activeClassName="ViewHeader__backButton_active"
          onClick={props.onGoBack}
        >
          <SvgIcon
            className="ViewHeader__backButton__svgIcon"
            icon={SvgIcons.Back}
          />
        </Button>
      ) : null}
      <div className="ViewHeader__content">
        {props.children}
      </div>
    </div>
  );
}

ViewHeaderView.propTypes = {
  className: T.string,
  enableMenuButton: T.bool,
  showBackButton: T.bool,
  onToggleMenu: T.func,
  onGoBack: T.func,
};

ViewHeaderView.defaultProps = {
  className: '',
  enableMenuButton: true,
  showBackButton: false,
};



// WEBPACK FOOTER //
// ./src/js/components/views/ViewHeader/ViewHeaderView.js